import { type ReactNode, createContext, useContext, useMemo } from 'react';
import { createTranslator } from './translator';
import type { LanguageCode, Translator } from './types';

type ContextValue = {
  language: LanguageCode;
  t: Translator;
};

const LanguageContext = createContext<ContextValue | null>(null);

type ProviderProps = {
  language: LanguageCode;
  children: ReactNode;
};

export function LanguageProvider({ language, children }: ProviderProps) {
  const value = useMemo<ContextValue>(() => {
    return { language, t: createTranslator(language) };
  }, [language]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useTranslator(): Translator {
  const ctx = useContext(LanguageContext);
  if (ctx) return ctx.t;
  return createTranslator('vi');
}

export function useLanguage(): LanguageCode {
  const ctx = useContext(LanguageContext);
  return ctx?.language ?? 'vi';
}
